var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntimationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99971 13.3337V10.0003M9.99971 6.66699H10.008M18.333 10.0003C18.333 14.6027 14.6021 18.3337 9.99971 18.3337C5.39734 18.3337 1.66638 14.6027 1.66638 10.0003C1.66638 5.39795 5.39734 1.66699 9.99971 1.66699C14.6021 1.66699 18.333 5.39795 18.333 10.0003Z",
    stroke: "#9193A1",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntimationIcon);
export default __webpack_public_path__ + "static/media/intimationIcon.a563b4c918e7994272abed4b9c5449b3.svg";
export { ForwardRef as ReactComponent };